<div class="preview-container">
  @if (accounts.length === 0) {
    <div class="empty-state">
      <p>No accounts found with selected filters</p>
    </div>
  }
  @if (accounts.length > 0) {
    <div>
      <div class="preview-header">
        <span class="search-filter">
          <p-iconField iconPosition="left" class="input-bar">
            <p-inputIcon class="pi pi-search"></p-inputIcon>
            <input
              pInputText
              [(ngModel)]="searchValue"
              class="account-search-bar"
              (input)="dtAccounts.filterGlobal($event.target.value, 'contains')"
              placeholder="Search Accounts..."/>
          </p-iconField>
        </span>
      </div>
      <p-table
        #dtAccounts
        [value]="accounts"
        [globalFilterFields]="['name', 'id']"
        [scrollable]="true"
        scrollHeight="300px"
        class="p-datatable-gridlines">
        <ng-template pTemplate="header">
          <tr>
            <th>Account Name</th>
            <th>Account ID (MPOP ID)</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-account>
          <tr
            [ngClass]="{'excluded-row': !isAccountSelected(account)}"
            (click)="toggleAccountSelection(account)"
            class="clickable-row">
            <td>{{ account.name }}</td>
            <td>{{ account.id }}</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="selection-message">
        @if (getExcludedAccounts().length === 0) {
          <p><i>Select Accounts to exclude from filter</i></p>
        } @else {
          <p><strong>Excluded Accounts:</strong></p>
          <div class="excluded-chips">
            @for (acc of getExcludedAccounts(); track acc) {
              <span class="p-chip">
                <span class="p-chip-text">{{ acc.name }} ({{ acc.id }})</span>
              </span>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
<div class="preview-actions">
  <button
    pButton
    type="button"
    label="Clear Excluded"
    class="p-button-secondary p-mr-2"
    (click)="clearSelected()">
  </button>
  <button
    pButton
    type="button"
    label="Close"
    class="p-button-outlined"
    (click)="closeWithPayload()">
  </button>
</div>
